'use strict';

const { h } = require('phy');
const { connect } = require('preact-redux');

const HeroTitle = require('../../coupons/views/hero-title');
const MainMenu = require('../../header/views/main-menu');
const LayoutServiceLinks = require('../../header/views/layout-service-links');

function Header({
  keyAuthData,
  merchants,
  activePage,
  routes,
  isTouch,
  layoutServiceMenu,
  tag,
}) {
  return h('section', [
    h(LayoutServiceLinks, { layoutServiceMenu }),
    h(HeroTitle, { tag }),
    h(MainMenu, { keyAuthData, merchants, activePage, routes, isTouch }),
  ]);
}

const mapStateToProps = state => ({
  isTouch: state.isTouch,
  layoutServiceMenu: state.layoutServiceMenu,
});

module.exports = connect(mapStateToProps)(Header);
